import {
  calculateContrast,
  formatContrastRatio,
  getWCAGLevel,
} from '@/utils/leonardo/contrast';
import {
  formatAPCAContrast,
  getAPCALevel,
} from '@/utils/leonardo/apca';
import { normalizeHex } from './normalizeHex';

export interface CheckContrastInput {
  foreground: string;
  background: string;
  standard?: 'wcag2' | 'apca';
}

export interface CheckContrastResult {
  foreground: string;
  background: string;
  standard: 'wcag2' | 'apca';
  wcag2: {
    ratio: number;
    formatted: string;
    level: ReturnType<typeof getWCAGLevel>;
  };
  apca: {
    lc: number;
    formatted: string;
    level: ReturnType<typeof getAPCALevel>;
  };
}

export const executeCheckContrast = (
  input: CheckContrastInput
): CheckContrastResult => {
  const foreground = normalizeHex(input.foreground);
  const background = normalizeHex(input.background);
  const standard = input.standard ?? 'wcag2';

  const wcagRatio = calculateContrast(foreground, background, 'wcag2');
  const apcaLc = calculateContrast(foreground, background, 'wcag3');

  return {
    foreground,
    background,
    standard,
    wcag2: {
      ratio: Math.round(wcagRatio * 100) / 100,
      formatted: formatContrastRatio(wcagRatio),
      level: getWCAGLevel(wcagRatio),
    },
    apca: {
      lc: Math.round(apcaLc * 100) / 100,
      formatted: formatAPCAContrast(apcaLc),
      level: getAPCALevel(apcaLc),
    },
  };
};
